<template>
  <div class="container">


    <div class="content">

      <div class="chat list-scroll" id="chat-record">

        <template v-for="row in chatHistory">

          <div class="message-item-left" :key="row.content" v-if="row.type == 'system'">

            <div style="display: flex;">

              <div class="avatar">
                <img style="width: 100%;" :src="require(`@/assets/system.jpg`)" alt="" srcset="" />
              </div>

              <div class="message">
                <div v-html="row.content"></div>
              </div>

            </div>


          </div>
          <template v-else>

            <div class="message-item-right" v-if="['image', 'text'].includes(row.type)"
              :key="row.content + '-question'">

              <div style="display:flex">

                <div class="message-right">
                  <template v-if="row.type == 'text'">
                    {{ row.content }}
                  </template>

                  <template v-if="row.type == 'image'">

                    <img :src="row.content" style="width: 20rem;">
                  </template>

                </div>
                <div class="avatar">
                  <img style="width: 100%;" :src="require(`@/assets/user.jpg`)" alt="" srcset="" />
                </div>
              </div>


            </div>
          </template>
        </template>
      </div>
      <div style="padding: 1.5rem;height: 8rem;">
        <div class="enter">

          <input type="text" style="width: calc(100% - 20rem); border: 1.5px solid #03A9F4;" v-model="currentInput"
            :disabled="spinning" placeholder="请输入" @keyup.enter="sendToserve" />

          <div style="width: 20rem;display: flex;justify-content: space-evenly;">

            <a-button @click="sendToserve" type="primary">发送</a-button>
            <a-upload accept="image/*" :show-upload-list="false" :custom-request="handleChange">

              <a-button type="primary" class="ant-upload-text">
                上传图片
              </a-button>

            </a-upload>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>

import { putAction, download, getAction } from '@/request/http.js'


export default {
  data() {
    return {
      chatHistory: [],
      spinning: false,
      session_id: "",
      currentInput: "",
      imgList: []

    }
  },
  mounted() {

    this.chatHistory.push({
      "type": "system",
      "content": "<span>您好，我是一名编织袋销售顾问, 请问有什么可以帮助您的?</span>"
    })

    this.agent = location.href.split('//').pop().match(/(?<=\/).*?(?=#)/g)[0].replace('?', '')


  },

  methods: {

    init() {
    },


    async sendToserve() {
      if (!this.currentInput) {
        this.$message.warning('请输入内容')
        return false
      }
      this.spinning = true;

      this.chatHistory.push({
        type: "text",
        content: this.currentInput
      })


      let paylaod = {
        prompt: this.currentInput,
        agent:this.agent
      }

      if (this.imgList.length) {
        paylaod.image = this.imgList
      }

      if (this.session_id) {
        paylaod.session_id = this.session_id
      }
      this.chatHistory.push({
        type: "system",
        content: "正在回复中......"
      })
      fetch(`${process.env.VUE_APP_BASE_URL}chat`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(paylaod)
      }).then(res => res.json()).then(res => {

        if (res.code == -1) {
          this.$message.warning(res.message)
          return false;
        }

        this.chatHistory.pop()

        // let res.data =

        this.chatHistory.push({
          type: "system",
          content: this.dealMsg(res.data)
        })
        if (res.session_id) {
          this.session_id = res.session_id
        }
        this.imgList = []
        this.currentInput = ''
        this.spinning = false;

      }).finally(() => {
        this.currentInput = ''
        this.spinning = false;
      })


    },


    handleChange(file) {
      const formData = new FormData();
      console.log('file', file)
      formData.append('files', file.file);

      this.loading = true;


      fetch(`${process.env.VUE_APP_BASE_URL}upload`, {
        method: "post",
        body: formData
      }).then(res => res.json()).then(res => {
        console.log('res', res)
        if (res.code == -1) {
          this.$message.warning(res.message)
          return false;
        }

        this.chatHistory.push({
          type: "image",
          content: `${process.env.VUE_APP_BASE_URL}image/${res.data}`
        })
        this.imgList.push(`${process.env.VUE_APP_BASE_URL}image/${res.data}`)
      }).finally(() => {
        this.loading = false;
      })


    },

    dealMsg(msg) {
      msg = msg.split('\n')
      msg = msg.map(ele => {
        if (ele.match(/https.*?(jpg|png|jpeg)/)) {
          return `<img src="${ele.match(/https.*?(jpg|png|jpeg)/)[0]}">`
        }
        //  else if (ele.match(/http.*?\.mp4/)) {
        //   return `<video src="${ele.match(/http.*?\.mp4/)[0]}" controls></video>`
        // }
        else if (!ele) {
          return `<br/>`
        } else {
          return `<span>${ele}</span>`
        }
      })

      return msg.join('<br/>')
    }

  },
  created() {

  },
  components: {
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: rgb(45 30 142 / 7%);
  background-size: 100% 100%;
  padding: 5rem 10rem;
  justify-content: space-between;
}



.content {
  width: 100%;
  height: 100%;
  bottom: 0;
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0px -1px 20px 15px rgba(0, 0, 0, 0.1);

}

.chat {
  width: 100%;
  height: calc(100% - 9rem);
  padding: 3rem 2rem 2rem;

}

.enter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5rem;
  border-radius: 5rem;
  overflow: hidden;
  /* background: white; */
  padding: 0 2rem;
}

.enter input {

  width: calc(100% - 7rem);
  border: none;
  border-radius: 3rem;
  height: 3.6rem;
  padding-left: 1rem;
}

.avatar {
  width: 4.4rem;
  border-radius: 50%;
  overflow: hidden;
  height: 4.4rem;
  /* background: white; */
}

.name {
  font-weight: bold;
  font-size: 1.5rem;
  margin-left: 1.5rem;
}

.time {
  font-size: 1.2rem;
  font-family: PingFangSCRegular;
  font-weight: 400;
  /* color: #C3C3C3; */
}

.message {
  padding: 1rem;
  background: #2196f333;
  border-radius: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  width: calc(100% - 5rem);
  position: relative;
  word-break: break-all;
  margin-left: 4.5rem;
  white-space: break-spaces;
}

.message-item-left {

  width: 100%;
  margin-bottom: 1.8rem;
  padding: 0 20% 0 0;

}

.message-item-right {

  width: 100%;
  margin-bottom: 1.8rem;
  padding: 0 0 0 20%;
  display: flex;
  flex-direction: column;
  align-items: end;

}

.recommend div {

  padding: 0.5rem 1rem;
  margin-top: 0.8rem;
  border-radius: 2rem;
  margin-right: 1.8rem;
  cursor: pointer;
  background: rgba(53, 39, 152, 1);
  color: white;

}

.recommend div:hover {

  background: #12ba104a;


}

.message-right {
  width: fit-content;
  padding: 1rem;
  background: #2196f333;
  border-radius: 2rem;
  /* color: white; */
  margin-right: 1.5rem;
  font-size: 1.6rem;
  letter-spacing: 0.1rem;
  position: relative;
  word-break: break-all;


}

.bot-type {

  width: 16rem;
  height: 16rem;
  position: relative;
  cursor: pointer;
}

.select-icon {
  position: absolute;
  width: 5rem;
  padding: 0.5rem;
  bottom: 0;
  right: -2rem;
  border-radius: 50%;
  background: white;
}

.bot-type .shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 2rem;
  background: white;
}

.bot-select-shadow1 {
  transition: transform 0.5s linear;
  transform: rotate(10deg);
  background-color: #ffe0d4 !important
}

.bot-select-shadow2 {
  transition: transform 0.5s linear;
  /* transform: rotate(-10deg); */
  background: linear-gradient(#ffa17f, #ffc5ab) !important;
}

.bot-info {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 1rem;
}

.img-container {
  position: relative;
  width: 100%;
  height: 50%;
}

.bot-img {
  bottom: 0;
  width: 40%;
}

.bot-type-title {
  font-size: 1.3rem;
  color: black;
  font-weight: 400;
  letter-spacing: 0.1rem;

}

.bot-type-desc {
  font-size: 1rem;
  /* background: rgb(167 167 167 / 22%); */
  padding: 0.2rem 0.8rem;
  border-radius: 1rem;
}




.text {
  color: #000000;
  font-size: 1.6rem;
  letter-spacing: 1px;
  margin: 3rem 0 1.5rem;
  font-weight: 500;
}

.message-icon {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 1.4rem;
  left: -0.5rem;
  background: #fc7b5f;
  transform: rotate(45deg);
}

.message-icon2 {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 1.4rem;
  right: -0.5rem;
  background: #fed1c6;
  transform: rotate(45deg);
}

.back {
  width: 2rem;
  height: 2rem;
  position: absolute;
  border-radius: 50%;
  background: red;
  left: 2rem;
  top: 1rem;
  cursor: pointer;
}

.title-text {
  font-family: Inter;
  font-size: 2.5rem;
  font-weight: 300;
  text-align: center;
  color: white;

}

.name {
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 3.6rem;
  text-align: center;
  /* color: white; */

}

.message>>>img {
  width: 30rem;
}

.message>>>video {
  width: 30rem;
}
</style>

<style>
.message a {
  color: #E0E0E0 !important;
}
</style>